export const PAYMENT_METHODS = {
  ACCOUNT_FORM: 'account_form',
  HOSTED_PAYMENT_PAGE: 'hosted_payment_page',
};



// WEBPACK FOOTER //
// ./src/constants/payment-methods.js